// component
import { useTranslation } from 'react-i18next';
import admin_ic from '../../../assets/images/dashboard/admin_ic.svg'
import order_ic from '../../../assets/images/dashboard/order_ic.svg'
import advertise_ic from '../../../assets/images/dashboard/advertise_ic.svg'
import driver_ic from '../../../assets/images/dashboard/driver_ic.svg'
import coupon_ic from '../../../assets/images/dashboard/coupon_ic.svg'
import merchant_ic from '../../../assets/images/dashboard/merchant_ic.svg'
import customer_ic from '../../../assets/images/dashboard/ic_user.svg'
import promotion_ic from '../../../assets/images/dashboard/promotion_ic.svg'
import { COUPON_ROUTE, DRIVER_REPORT_ROUTE, PAYMENT_REPORT_ROUTE, PROMOTION_ROUTE } from '../../../routes/paths';
import DASHBOARD_ICON from '../../../assets/images/drawer_icons/dashboard_icon.svg';
import { ListItemText } from '@mui/material';

// ----------------------------------------------------------------------

// const icon = (name: string) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

interface IconImageProps {
  imageUrl: string,
  width?: string,
  height?: string
}

const IconImage = ({ imageUrl, height = "24px", width = "24px" }: IconImageProps) => {
  return <img src={imageUrl} alt="" style={{
    width,
    height
  }} />
}

const useNavConfig = () => {
  const { t } = useTranslation("global");

  const navConfig = [
    {
      title: 'Dashboard',
      path: '/home',
      icon: <IconImage imageUrl={DASHBOARD_ICON} />,
    },
    {
      title: "Order",
      path: '/order',
      icon: <IconImage imageUrl={order_ic} />
    },
    {
      title: "Sale report",
      path: '/sales-report',
      icon: <IconImage imageUrl={order_ic} />
    },
    {
      title: "Order report",
      path: '/order-report',
      icon: <IconImage imageUrl={order_ic} />
    },
    {
      title: "Payment report",
      path: '/payment-report',
      icon: <IconImage imageUrl={order_ic} />
    },
    {
      title: "Driver report",
      path: '/driver-report',
      icon: <IconImage imageUrl={order_ic} />
    },
    {
      title: t('Customer'),
      path: '/customer',
      icon: <IconImage imageUrl={customer_ic} />
    },
    {
      title: t('Admin account'),
      path: '/adminAccount',
      icon: <IconImage imageUrl={admin_ic} />
    },
    {
      title: t('Product'),
      path: '/product',
      icon: <IconImage imageUrl={merchant_ic} />
    },
    {
      title: "Product Merchant",
      path: '/productMerchant',
      icon: <IconImage imageUrl={merchant_ic} />,
    },
    {
      title: 'Category',
      path: '/category',
      icon: <IconImage imageUrl={merchant_ic} />
    },
    {
      title: 'Jiffy Categories',
      path: '/categoriesBranch',
      icon: <IconImage imageUrl={merchant_ic} />
    },
    {
      title: 'branch Management',
      path: '/branch',
      icon: <IconImage imageUrl={merchant_ic} />
    },
    {
      title: 'merchants user',
      path: '/staff',
      icon: <IconImage imageUrl={merchant_ic} />
    },
    {
      title: 'Promotion',
      path: PROMOTION_ROUTE,
      icon: <IconImage imageUrl={promotion_ic} />
    },
    {
      title: 'All driver',
      path: '/driver',
      icon: <IconImage imageUrl={driver_ic} />
    },
    {
      title: 'Driver financial Clearance',
      path: '/driver-financial',
      icon: <IconImage imageUrl={driver_ic} />
    },
    {
      title: 'Delivery Fee management',
      path: '/deliveryFee',
      icon: <IconImage imageUrl={driver_ic} />
    },
    {
      title: 'Coupon',
      path: COUPON_ROUTE,
      icon: <IconImage imageUrl={coupon_ic} />
    },
    {
      title: 'Pop-up',
      path: '/popUp',
      icon: <IconImage imageUrl={advertise_ic} />
    },
    {
      title: 'Banner',
      path: '/banner',
      icon: <IconImage imageUrl={advertise_ic} />
    },
    {
      title: 'notification',
      path: '/notification',
      icon: <IconImage imageUrl={advertise_ic} />,

    },
  ];

  return {
    navConfig
  }
}



export default useNavConfig;
